module.exports = __webpack_public_path__ + "img/timeline-17.0b28d218.svg";